import * as types from '../mutation-types'

const state = {
  // Lendo os produtos selecionados de string para JSON de localStorage
  main: {
    addCarrinho: false,
    login: false,
    endereco: false,
    finalizarCompra: false
  }
}

const mutations = {
  [types.SHOW_MODAL_ADDCARRINHO] (state) {
     state.main.addCarrinho = true;
  },
  [types.SHOW_MODAL_LOGIN] (state) {
    state.main.login = true;
  },
  [types.SHOW_MODAL_ENDERECO] (state) {
    state.main.endereco = true;
  },
  [types.HIDE_MODAL_ENDERECO] (state) {
    state.main.endereco = false;
  },
  [types.SHOW_MODAL_FINALIZAR_COMPRA] (state) {
    state.main.finalizarCompra = true;
  },
  [types.HIDE_MODAL_FINALIZAR_COMPRA] (state) {
    state.main.finalizarCompra = false;
  },
  [types.HIDE_ALL_MODALS] (state) {
    state.main.finalizarCompra = false;
    state.main.addCarrinho = false;
    state.main.login = false;
    state.main.endereco = false;
  },


}

export default {
  state,
  mutations
}

